import * as React from 'react';
import { HashLoader } from 'react-spinners';

export const AdminHomeLoader: React.FC = (): JSX.Element => (
  <div className="h-screen w-52 mx-auto flex flex-col justify-center items-center">
    <HashLoader size={100} color="#000" />
    <h2 className="text-xl font-semibold mt-5">Loading...</h2>
  </div>
);
